/**
 * @Description: 路由配置
 * @Date: 2019-9-25
 * @Modify:
 * @Author: zhangxiaofeng
 */
// const Home = r => require.ensure([], () => r(require('views/budget/home')), 'Home');
/* Layout */
import Layout from '@/components/layout/Index.vue'
export default [
  {
    path: '/database',
    component: Layout,
    // redirect: '/database/home',
    children: [
      {
        path: 'home',
        component: () => import('@/views/database/children/Home.vue'),
        meta: { title: '电子档案室', icon: 'home', noCache: true, keepAlive: false, auth: true }
      },
      {
        path: 'manage',
        component: () => import('@/views/CommonView.vue'),
        redirect: '/database/manage/configTask',
        meta: { title: '权限设置', icon: 'home', noCache: true, keepAlive: false, auth: true },
        children: [
          {
            path: 'configTask',
            component: () => import('@/views/database/children/manage/ConfigTask.vue'),
            meta: { title: '分配审核任务', icon: 'home', noCache: true, keepAlive: false, auth: true }
          },
          {
            path: 'setPrivilege',
            component: () => import('@/views/database/children/manage/SetPrivilege.vue'),
            meta: { title: '设置免审核人员', icon: 'home', noCache: true, keepAlive: false, auth: true }
          }
        ]
      },
      {
        path: 'basis',
        component: () => import('@/views/CommonView.vue'),
        meta: { title: '企业造价依据', icon: 'home', noCache: true, keepAlive: false, auth: true },
        children: [
          {
            path: 'inventory',
            component: () => import('@/views/database/children/basis/Inventory'),
            meta: { title: '企业清单数据', icon: 'home', noCache: true, keepAlive: false, auth: true }
          },
          {
            path: 'quota',
            component: () => import('@/views/database/children/basis/Quota'),
            meta: { title: '企业定额数据', icon: 'home', noCache: true, keepAlive: false, auth: true }
          },
          {
            path: 'material',
            component: () => import('@/views/database/children/basis/Material'),
            meta: { title: '企业人材机数据', icon: 'home', noCache: true, keepAlive: false, auth: true }
          },
          {
            path: 'combination',
            component: () => import('@/views/database/children/basis/Combination'),
            meta: { title: '企业组价数据', icon: 'home', noCache: true, keepAlive: false, auth: true }
          }
        ]
      },
      {
        path: 'data',
        component: () => import('@/views/CommonView.vue'),
        meta: { title: '企业资料库', icon: 'home', noCache: true, keepAlive: false, auth: true },
        children: [
          {
            path: 'record',
            component: () => import('@/views/database/children/data/Record.vue'),
            meta: { title: '电子备案库', icon: 'home', noCache: true, keepAlive: false, auth: true }
          },
          {
            path: 'shared',
            component: () => import('@/views/database/children/data/Shared.vue'),
            meta: { title: '共享资料库', icon: 'home', noCache: true, keepAlive: false, auth: true }
          },
          {
            path: 'record/:id', // 项目详情
            redirect: 'record/:id/files/:status?',
            component: () => import('@/views/project/children/detail/Index'),
            children: [
              {
                path: 'files/:status?', // 项目文件
                name: 'recordFiles',
                component: () => import('@/views/project/children/detail/children/Files'),
                meta: { title: '备案库', icon: 'home', noCache: true, keepAlive: false, auth: true }
              },
              {
                path: 'members', // 项目成员
                name: 'recordMembers',
                component: () => import('@/views/project/children/detail/children/Members'),
                meta: { title: '备案库', icon: 'home', noCache: true, keepAlive: false, auth: true }
              },
              {
                path: 'recycle', // 项目回收站
                name: 'recordRecycle',
                component: () => import('@/views/project/children/detail/children/Recycle'),
                meta: { title: '备案库', icon: 'home', noCache: true, keepAlive: false, auth: true }
              },
              {
                path: 'logs', // 项目操作详情
                name: 'recordLogs',
                component: () => import('@/views/project/children/detail/children/Logs'),
                meta: { title: '备案库', icon: 'home', noCache: true, keepAlive: false, auth: true }
              }
            ]
          }
        ]
      },
      {
        path: 'no_permission',
        component: () => import('@/components/common/NoAuthPage/Index.vue'),
        meta: { title: '企业数据库-无权限', icon: 'home', noCache: true, keepAlive: false, auth: true }
      }
    ]
  },
  {
    path: '/database/material/upload',
    component: () => import('@/views/database/children/material/Uploadexcel'),
    meta: { title: '人材机导入Excel', icon: 'home', noCache: true, keepAlive: false, auth: true }
  }
]
